import PageMetatags from 'layout/PageMetatags';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { ContentCard } from '../../layout/ContentCard';
import WorkshopUpdateForm from './WorkshopUpdateForm';

export interface IWorkshopUpdateDataPage {}

export const WorkshopUpdateDataPage: FC<IWorkshopUpdateDataPage> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { id } = useParams();
  const workshop_id = Number(id);
  if (!workshop_id || isNaN(workshop_id)) {
    navigate('/404', { replace: true });
    return null;
  }

  return (
    <>
      <PageMetatags title={`${t('pages:workshops.update.meta.title')}`} />

      <ContentCard header={t('pages:workshops.update.title')} contentDescription={t('pages:workshops.update.subtitle')}>
        <WorkshopUpdateForm workshop_id={workshop_id} />
      </ContentCard>
    </>
  );
};

export default WorkshopUpdateDataPage;
